import React, {Component} from 'react';

class Tags extends Component {

    render() {
        return (
            <div>
                Tags 2
            </div>
        );
    }
}

export default Tags;